import types from '../types/signup'

export default class item {

  static open() {
    return {
      type: types.OPEN,
    }
  }

  static close() {
    return {
      type: types.CLOSE,
    }
  }

}



// WEBPACK FOOTER //
// ./src/sections/signup/actions/signup.js